export default {
  title: 'Dati bancari',
  sections: {
    personal_info: 'Dati personali',
    address: 'Indirizzo',
  },
  labels: {
    account_number: 'Numero di conto',
    routing_number: 'Numero di routing',
    email: 'E-mail',
    full_name: 'Nome completo',
    street: 'Indirizzo',
    zip_code: 'Codice postale',
    city: 'Città',
  },
  tooltip: '{{field}} copiato negli appunti!',
};
